import {FieldRangeDates} from "src/modules/types";

export class GetFieldRangeDates {
  static readonly type = '[FieldMonitoring] Get field range dates';

  constructor(public payload: FieldRangeDates) {
  }
}
